import React, { useState } from "react";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar";
import SharedFAQ from "./components/SharedFAQ";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      className="w-full"
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function Faq() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="text-white text-2xl py-8 md:px-12 px-4 flex items center bg-[#2EBAA3]">
        <span>FAQs</span>
      </div>
      <Box
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex'}}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        TabIndicatorProps={{style:{width:'5px', borderRadius:'10px'}}}
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab label="General" {...a11yProps(0)} style={{height:'6vh'}}/>
        <Tab label="Client" {...a11yProps(1)} style={{height:'6vh'}}/>
        <Tab label="Vendor" {...a11yProps(2)} style={{height:'6vh'}}/>
        <Tab label="Consultant" {...a11yProps(3)} style={{height:'6vh'}}/>
      </Tabs>
      <TabPanel value={value} index={0}>
        <SharedFAQ section={"General"}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SharedFAQ section={"Client"}/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <SharedFAQ section={"Vendor"}/>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <SharedFAQ section={"Consultant"}/>
      </TabPanel>
    </Box>
    <br/>
      <Footer />
    </div>
  );
}
